const n = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M9.429,2.75A.251.251,0,0,0,9.657,2.4L8.836.552A1,1,0,0,0,7.941,0H5.75A.25.25,0,0,0,5.5.25V2.5a.25.25,0,0,0,.25.25Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
    <path
        d="M4.25,2.75A.25.25,0,0,0,4.5,2.5V.25A.25.25,0,0,0,4.25,0H2.059a1,1,0,0,0-.905.573L.344,2.4a.247.247,0,0,0,.018.237.251.251,0,0,0,.21.114Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
    <path
        d="M9.75,3.75H.25A.25.25,0,0,0,0,4V8.5A1.5,1.5,0,0,0,1.5,10h7A1.5,1.5,0,0,0,10,8.5V4A.25.25,0,0,0,9.75,3.75Zm-2,4.375H6.5a.625.625,0,0,1,0-1.25H7.75a.625.625,0,0,1,0,1.25Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  n as default
};
